import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiPut, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { auditLogKeys, estimateKeys } from '@/lib/queryKeys';
import type { Estimate } from '@/types/estimate';

/**
 * NOT-247 — Replace an estimate's tags in any status via the dedicated
 * `PUT /estimates/:id/tags` endpoint. Tags are internal metadata, so this
 * bypasses the status guard / draftVersion bump / PDF invalidation of the
 * general estimate update and records the change on the Activity feed.
 */
export function useReplaceEstimateTags(estimateId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<Estimate, { tagIds: string[] }>({
    mutationFn: (body) =>
      apiPut<Estimate>(operationsClient, opsEstimateEndpoints.tags(estimateId), body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(estimateId) });
      void queryClient.invalidateQueries({
        queryKey: auditLogKeys.byEntity('estimate', estimateId),
      });
      toast.success('Tags updated');
    },
  });
}
